import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'add-date-format-dialog',
  templateUrl: './add-date-format-dialog.component.html',
  styleUrls: ['./add-date-format-dialog.component.scss']
})
export class AddDateFormatDialogComponent implements OnInit {

  format: string;
  arrDateFormats = [
  
    { value: "yyyy-MM-dd" },
    { value: "dd-MM-yyyy" },
    { value: "MM-dd-yyyy" },
    { value: "yyyy/MM/dd" },
    { value: "dd/MM/yyyy" },
    { value: "MM/dd/yyyy" },
    { value: "yyyyMMdd" },
    { value: "ddMMyyyy" },
    { value: "MMddyyyy" }
  ];
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<AddDateFormatDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public arrDateFormatMappingDetail: any,
    public dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    this.format = this.arrDateFormatMappingDetail.format;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSave(): void {
    this.dialogRef.close({ format: this.format });
    alert("Default Date Format Saved")
  }

}
